<template>
  <div>
    <a-modal
      :visible="modalVisible"
      class="modal-main forget-password"
      :footer="null"
      :maskClosable="false"
      @cancel="handleCloseModal"
    >
      <h1 class="modal-title">Forget Password</h1>
      <a-form layout="vertical" :model="formList" :rules="rules" ref="formList">
        <a-form-item name="loginEmail">
          <LineInput
            class="input-item"
            v-model:value="formList.loginEmail"
            placeholder="Login Email"
          ></LineInput>
        </a-form-item>

        <a-form-item name="verifycode">
          <LineInput
            class="input-item"
            v-model:value="formList.verifyCode"
            placeholder="Verification Code"
            :isVerifyCode="true"
            :maxLength="6"
            @get-code="handleGetCode"
          ></LineInput>
        </a-form-item>

        <div class="button" @click="handleSubmit">
          Submit
        </div>
        <div class="cancel-button" @click="handleBackToLogin">
          Back to login
        </div>
      </a-form>
    </a-modal>
    <ResetPasswordModal
      ref="resetPassword"
      @back-to-login="handleBackToLogin"
    ></ResetPasswordModal>
  </div>
</template>

<script>
import { validateEmail, validateVarifyCode } from '@/utils/validate'
import LineInput from '@/components/LineInput'
import ResetPasswordModal from '@/components/ResetPasswordModal'

export default {
  name: 'ForgetPasswordModal',
  components: { LineInput, ResetPasswordModal },
  data() {
    let validateMail = async (rule, value) => {
      if (!value) {
        return Promise.reject('Login email is required')
      } else if (!validateEmail(value)) {
        return Promise.reject('Please enter the correct email format')
      } else {
        return Promise.resolve()
      }
    }
    let validateCode = async (rule, value) => {
      if (!value) {
        return Promise.reject('Verification code is required')
      } else if (!validateVarifyCode(value)) {
        return Promise.reject('Please enter the correct verification code')
      } else {
        return Promise.resolve()
      }
    }
    return {
      modalVisible: false,
      formList: {
        loginEmail: undefined,
        verifyCode: undefined,
      },
      rules: {
        loginEmail: [{ validator: validateMail, trigger: 'blur' }],
        verifyCode: [{ validator: validateCode, trigger: 'blur' }],
      },
    }
  },
  methods: {
    showModal() {
      this.modalVisible = true
    },
    handleCloseModal() {
      this.modalVisible = false
      this.formList = {
        loginEmail: undefined,
        verifyCode: undefined,
      }
    },
    handleGetCode() {
      this.$refs.formList.validate(['loginEmail']).then(() => {
        this.$store.dispatch(
          'base/GetVerifyCodeByEmail',
          this.formList.loginEmail,
        )
      })
    },
    handleSubmit() {
      this.$refs.formList.validate().then(() => {
        this.$store.dispatch('base/CheckVerifyCode', this.formList).then(() => {
          this.$refs.resetPassword.showModal()
          this.modalVisible = false
        })
      })
    },
    handleBackToLogin() {
      this.modalVisible = false
      this.$emit('show-modal')
    },
  },
}
</script>

<style></style>
